import React from 'react'

import { GridLoader, PulseLoader, BarLoader } from 'react-spinners'

const LoadingScreen = (props) => {
  const Spinner = getSpinnerType(props.loaderType)

  return (
    <React.Fragment>
      <br/>
      <br/>
      <Spinner
        css={`display: block; margin: 0 auto;`}
        sizeUnit={"px"}
        size={20}
        color='#cf1a28'
      />
      {props.text ?
        <h5 style={{textAlign: 'center'}}>
          {props.text}...
        </h5>
        :
        null
      }
    </React.Fragment>
  )
}

LoadingScreen.defaultProps = {
  loaderType: 'GridLoader',
}

const getSpinnerType = (loaderType) => {
  switch (loaderType) {
    case 'GridLoader':
      return GridLoader
    case 'PulseLoader':
      return PulseLoader
    case 'BarLoader':
      return BarLoader
    default:
      return GridLoader
  }
}

export default LoadingScreen
